const checkPendencies = (validation, fieldNames) => {
  return Object.entries(validation)
    .filter((x) => !x[0].startsWith("$"))
    .filter((x) => x[1].$invalid)
    .map((x) => fieldNames[x[0]]);
};

const totalFields = (validation) => {
  return Object.entries(validation).filter((x) => !x[0].startsWith("$")).length;
};

const getPercentage = (validation, fieldNames) => {
  const total = totalFields(validation);
  const totalPendencies = checkPendencies(validation, fieldNames).length;
  return parseFloat((100 - (totalPendencies / total) * 100).toFixed(2));
};

const hasCriticalFields = (paths, validation) => {
  const invalidFields = paths
    .map((x) => deepFind(validation, x))
    .filter((x) => (x ? x.$invalid : false));
  return !!invalidFields.length;
};

const deepFind = (obj, path) => {
  let paths = path.split(".");
  let current = obj;
  let i;

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] === undefined) {
      return undefined;
    } else {
      current = current[paths[i]];
    }
  }
  return current;
};

export default {
  checkPendencies,
  totalFields,
  getPercentage,
  hasCriticalFields,
};
